import { atom } from 'jotai'

import { Access } from '../lib'
import * as s1 from './state.profile'

// read-only derived atom
//TODO: to rename isTeam --> inGroup (role.extra.inGroup)
export const isTeamAtom = atom(
	// getter
	(get) => {
		const profile = get(s1.profileAtom)
		const inGroup: string = new Access(profile).inGroup() ?? ''
		return inGroup
	}
)
